const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 379.47 119.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M369.66,494.84v12.77h30.52c-.93,7.16-3.32,12.41-7,16.09-4.46,4.46-11.42,9.34-23.57,9.34-18.79,0-33.48-15.16-33.48-34s14.69-34,33.48-34a32.46,32.46,0,0,1,23,9.14l9-9a44.09,44.09,0,0,0-32-13c-25.75,0-47.4,21-47.4,46.72s21.65,46.72,47.4,46.72c13.91,0,24.4-4.57,32.6-13.08,8.41-8.41,11.06-20.3,11.06-29.85a41,41,0,0,0-.67-8Z",
    transform: "translate(-322.26 -452.33)",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.47,484.46c-16.66,0-30.26,12.67-30.26,30.16,0,17.34,13.6,30.16,30.26,30.16s30.26-12.77,30.26-30.16S468.13,484.46,451.47,484.46Zm0,48.43c-9.14,0-17-7.53-17-18.27s7.89-18.27,17-18.27,17,7.42,17,18.27S460.61,532.89,451.47,532.89Z",
    transform: "translate(-322.26 -452.33)",
    style: {
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.83,491.21h-.47c-3-3.53-8.67-6.75-15.88-6.75-15.05,0-28.19,13.13-28.19,30.16s13.13,30.16,28.19,30.16c7.22,0,12.93-3.22,15.88-6.85h.47v4.2c0,11.52-6.18,17.7-16.09,17.7-8.1,0-13.13-5.81-15.21-10.75L557,553.87a28.73,28.73,0,0,0,26.73,17.81c15.52,0,28.66-9.14,28.66-31.41V486H599.83Zm-15.21,41.68c-9.14,0-16.09-7.79-16.09-18.27,0-10.64,7-18.27,16.09-18.27s16.09,7.79,16.09,18.38S593.66,532.89,584.62,532.89Z",
    transform: "translate(-322.26 -452.33)",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,484.46c-16.66,0-30.26,12.67-30.26,30.16,0,17.34,13.6,30.16,30.26,30.16s30.26-12.77,30.26-30.16S535.62,484.46,519,484.46Zm0,48.43c-9.14,0-17-7.53-17-18.27s7.89-18.27,17-18.27,17,7.42,17,18.27S528.09,532.89,519,532.89Z",
    transform: "translate(-322.26 -452.33)",
    style: {
      fill: "#fbbc05"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.78,453.57h13v91.21h-13Z",
    transform: "translate(-322.26 -452.33)",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676,532.89c-6.75,0-11.52-3.06-14.64-9.14l40.34-16.66-1.35-3.43c-2.49-6.75-10.17-19.21-25.8-19.21s-28.45,12.2-28.45,30.16c0,16.92,12.77,30.16,29.9,30.16a30.09,30.09,0,0,0,25.13-13.34l-10.28-6.85c-3.43,5-8.1,8.31-14.85,8.31Zm-.93-37.12c5.35,0,9.92,2.75,11.42,6.64l-27.25,11.26C659.27,501,668.25,495.78,675.11,495.78Z",
    transform: "translate(-322.26 -452.33)",
    style: {
      fill: "#ea4335"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.7a5ec09a44a1a9187320efb4ca1eede1.svg";
export { ForwardRef as ReactComponent };